<template>
  <v-chip
    :color="color"
    class="font-weight-bold"
    :class="fontColor"
    small
  >
    {{ label }}
  </v-chip>
</template>

<script>
import { StageCardProgress } from '@/enums';
import { startCase } from 'lodash';

const PROGRESS_TO_STYLE_PROPS = {
  [StageCardProgress.IN_PROGRESS]: {
    color: 'primary',
    fontColor: 'white',
  },
  [StageCardProgress.COMPLETE]: {
    color: 'success',
    fontColor: 'white',
  },
  [StageCardProgress.PENDING]: {
    color: 'grey lighten-2',
    fontColor: 'grey--text text--darken-2',
  },
};

export default {
  name: 'StageCardProgressChip',
  props: {
    progress: {
      type: String,
      required: true,
      validator: (val) =>
        Object.values(StageCardProgress).includes(val),
    },
    pendingLabel: {
      type: String,
      default: startCase(StageCardProgress.PENDING),
    },
  },
  computed: {
    label() {
      return this.progress === StageCardProgress.PENDING
        ? this.pendingLabel
        : startCase(this.progress.toLowerCase());
    },
    color() {
      return this.styleProps?.color ?? 'grey lighten-2';
    },
    fontColor() {
      return (
        this.styleProps?.fontColor ?? 'grey--text text--darken-2'
      );
    },
    styleProps() {
      return PROGRESS_TO_STYLE_PROPS[this.progress];
    },
  },
};
</script>
